/**
 * MapsSection JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class MapsSection
 */
class MapsSection {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Get all google-map-elements.
        this.$mapElements = $( '.js-google-map' );
    }

    /**
     * Init all found galleries.
     */
    initGoogleMaps() {

        // Return early if no map elements found.
        if ( ! this.$mapElements.length ) {
            return;
        };

        // Return early if Google Maps API has not loaded.
        if ( ! ( 'google' in window && typeof google === 'object' && typeof google.maps === 'object' ) ) {
            console.warn( 'Google Maps API not loaded' );
            return;
        };

        // Get the link string from the localized variable. Use fallback if variable not found.
        let linkText;
        if ( typeof dptMapsSection !== 'undefined' && typeof dptMapsSection.link_string !== 'undefined' ) {
            linkText = dptMapsSection.link_string;
        } else {
            linkText = 'Open in Google Maps';
        }

        this.$mapElements.each( ( index, mapEl ) => {

            // Get location data.
            const locationInfo = {};
            locationInfo.lat = mapEl.getAttribute( 'data-lat' );
            locationInfo.lng = mapEl.getAttribute( 'data-lng' );

            // Return early if locationInfo is not set
            if ( ! locationInfo.lat || ! locationInfo.lng ) {
                return;
            }

            // Popoulate position object.
            const position = { lat: parseFloat( locationInfo.lat ), lng: parseFloat( locationInfo.lng ) };

            // Initialize the Map.
            const map = new google.maps.Map( mapEl, {
                center: position,
                zoom: 15,
                streetViewControl: false
            });

            // Add the location marker
            const marker = new google.maps.Marker({
                position: position,
                map: map
              });

            // Define infowindow content
            const contentString = `<div>
                <a href="http://www.google.com/maps/place/${locationInfo.lat},${locationInfo.lng}">${linkText}</a>
            </div>`;

            const infowindow = new google.maps.InfoWindow({
              content: contentString
            });

            marker.addListener( 'click', function() {
                infowindow.open( map, marker );
            });
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.initGoogleMaps();
    }
}

// Export the class reference.
module.exports = MapsSection;



// WEBPACK FOOTER //
// ./assets/scripts/maps-section.js